;(function() {
  document.addEventListener('bankrate:track:epSent', function(event) {
    var dataLayer = window.dataLayer || []

    var ccrarray =
      event && event.detail && event.detail.ccr
        ? event.detail.ccr.split(';')
        : [0, 0]
    var purid =
      event && event.detail && event.detail.purchaseid
        ? event.detail.purchaseid
        : '000000000000000000'
    var unitPrice =
      event && event.detail && event.detail.unitPrice
        ? event.detail.unitPrice
        : ''
    var cpcMarket =
      event && event.detail && event.detail.market ? event.detail.market : ''
    var cpcProduct =
      event && event.detail && event.detail.product ? event.detail.product : ''
    var cpcServingInstitution =
      event && event.detail && event.detail.product
        ? event.detail.servingInstitution
        : ''
    var cpcPosition =
      event && event.detail && event.detail.position
        ? event.detail.position
        : ''

    dataLayer.push({
      event: 'ecommerce-cpc',
      ecommerce: {
        purchase: {
          actionField: {
            action: 'purchase',
            id: purid,
            revenue: String(Math.round(unitPrice * 100) / 100),
            cpcMarket: cpcMarket,
            cpcProduct: cpcProduct,
            cpcServingInstitution: cpcServingInstitution,
            cpcPosition: cpcPosition
          },
          products: [
            {
              name: ccrarray[1],
              id: ccrarray[1],
              price: String(Math.round(unitPrice * 100) / 100),
              category: 'CCR',
              quantity: '1'
            }
          ]
        }
      }
    })
  })
})()
